// extracted by mini-css-extract-plugin
export default {"app-aside-nav__link":"efc656","app-aside-nav__link-icon":"af170d","app-aside-nav__link--active":"c568b8"};